import { Helmet } from "react-helmet-async";
import Screen from "../Layouts/Screen/Screen";
import { useEffect, useState } from "react";
import { Clipboard, CreditCard, Trash } from "react-feather";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useMessage, useTheme } from "../../global-components/src";
import { useAuth } from "../../global-components/src";
import Spinner, { LoadingThreeCircle } from "../../global-components/src/components/spinner/spiner";
import PreviewAds from "./preview-ads";
import { Ads, AdsPreview, ImagePost, Pix, QrCode, Payment } from "../../types";
import { errorMessage } from "../../utils/TextManagerTwo";
import { formatCurrency, formatCurrencyToFloat } from "../../utils/numbers";
import Ad from "./ad";
import { PACOCA_API_URL } from "../../global-components/src/utils/vars";
import { Icon } from "../../global-components/src/components/icon";
import { CirclePlus } from "lucide-react";
import { PostLoading } from "../../components/Post/post-loading";
import IncreaseLimit from "./increase-limit";
import { AdDashboard } from "./ads-dashboard";
import Cookies from "js-cookie";
import ItemList from "../../components/ItemList/ItemList";
import ReactMarkdown from "react-markdown";

const ViewAds = () => {
    const [text, setText] = useState("");
    const [price, setPrice] = useState<string | null>(null);
    const [images, setImages] = useState<ImagePost[]>([]);
    const [buttonText, setButtonText] = useState("Conversar");
    const [buttonUrl, setButtonUrl] = useState("");
    const [value, setValue] = useState<number | null>();
    const [terms, setTerms] = useState(false);
    const [expectedViews, setExpectedViews] = useState<number | null>(100);
    const navigate = useNavigate();
    const { setMessage } = useMessage();
    const { token, user } = useAuth();
    const { id } = useParams();
    const [loadingVerifyPayment, setLoadingVerifyPayment] = useState(false);
    const [ad, setAd] = useState<Ads | null>(null);
    const [isLoading, setIsLoading] = useState(false); // Adicione um estado para a senha
    const [loading, setLoading] = useState(false);
    const [loadingAnalyze, setLoadingAnalyze] = useState(false);
    const [copiado, setCopiado] = useState(false);
    const { isDarkMode } = useTheme();
    const [payment, setPayment] = useState<Payment | null>(null);
    const [pix, setPix] = useState<Pix | null>(null);
    const [analyze, setAnalyze] = useState("null");

    useEffect(() => {
        const loadAnalyze = async () => {
            if(!ad) return;
            if(ad.status != "ativo" && ad.status != "off" && ad.status != "online") return;
            const a =  localStorage.getItem(`analyzeAds${user?.id}_${id}`);
            if(a?.length){
                setAnalyze(a)
                return
            }

            setLoadingAnalyze(true);

            try {
                const response = await fetch(`${PACOCA_API_URL}/ai/analyze`, {
                    method: "POST",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                        "Accept": "text/event-stream",
                        "Cache-Control": "no-cache",
                        "Connection": "keep-alive"
                    },
                    body: JSON.stringify({
                        type: "ads",
                        ads_id: id
                    })
                });

                if (!response.ok || !response.body) {
                    const errorJson = await response.json();
                    console.error(response);
                    console.error("Erro detalhado:", errorJson);
                    if(errorJson.error){
                        throw new Error(errorJson.error);
                    }
                    throw new Error(`Erro ${response.status}: ${errorJson.detail || "Erro desconhecido."}`);
                }

                const reader = response.body.getReader();
                const decoder = new TextDecoder("utf-8");

                let finalText = "";
                let buffer = "";

                while (true) {
                    const { done, value } = await reader.read();
                    if (done) break;

                    buffer += decoder.decode(value, { stream: true });

                    const lines = buffer.split("\n");
                    buffer = lines.pop() || "";

                    for (const lineRaw of lines) {
                        const line = lineRaw.trim();

                        if (!line.startsWith("data:")) continue;

                        const data = line.replace("data:", "").trim();

                        if (data === "[DONE]") {
                            break;
                        }

                        try {
                            const json = JSON.parse(data);

                            const content = json.choices?.[0]?.delta?.content;

                            if (!content) continue;

                            finalText += content;

                            localStorage.setItem(`analyzeAds${user?.id}_${id}`, finalText);
                            setAnalyze(finalText)
                        } catch (err) {
                            console.warn("Erro parse:", data);
                        }
                    }
                }

            } catch (err: any) {
                const messageError = errorMessage(err);
                setAnalyze(messageError);
                console.error("Erro carregar dados: ", messageError);
                console.error("Erro carregar dados: ", err);
            } finally {
                setLoadingAnalyze(false);
            }
        };

        loadAnalyze()
    }, [ad])

    const copyLink = async () => {
        try {
            if(payment){
                await navigator.clipboard.writeText(payment?.pixCopiaECola);
                setCopiado(true);
                setTimeout(() => setMessage("Código Copiado", "success")); // Mensagem desaparece após 2 segundos
                setTimeout(() => setCopiado(false), 2000); // Mensagem desaparece após 2 segundos
            }
        } catch (err) {
            console.error("Erro ao copiar:", err);
        }
    };

    const onIncreaseLimit = () => {
        setAd(prev => {
            if (!prev) return prev

            return {
                ...prev,
                status: "online"
            }
        })
    }

    const verifyPayment = async (manual = false) => {
        if(manual) setLoadingVerifyPayment(true)
        
        try {
            const response = await axios.post(`${PACOCA_API_URL}/payments/ads/verify-payment/${payment?.txid}`, {
                months: pix?.txid,
            },{
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}` // Adicione o token aqui
                }
            });

            if(response.data.message){
                setMessage(response.data.message, "success");
                setPayment(null);
            }

            if(manual && response.data.danger){
                setMessage(response.data.danger, "warning");
            }
            
        } catch (err: any) {
            const messageError = errorMessage(err);
            setMessage(messageError, "error")
            console.error("Erro criar anuncio: ", messageError);
            console.error("Erro criar anuncio: ", err);
        } finally {
            setLoadingVerifyPayment(false)
        }
    };

    const loadData = async () => {
        const url = PACOCA_API_URL + `/ads/${id}`;

        if (loading) return;
        setLoading(true);

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data;

            if (data && data.ad)
                setAd(data.ad);

            if (data && data.payment)
                setPayment(data.payment);
        
            setLoading(false);
        } catch (err: any) {
            const messageError = errorMessage(err);
            setMessage(messageError, "error");
            console.error("Erro carregar dados: ", messageError);
            console.error("Erro carregar dados: ", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData()
    }, [])

    return (
        <>
            <Screen paddingTopTitle={true} title={`Meu anúncio`} contentMenu={
                <span className="cursor-pointer" onClick={() => navigate("/anuncios/novo")} style={{  marginTop: 2 }}>
                    <Icon size={24} style={{ margin: 0, cursor: "pointer" }} invertColor={!isDarkMode} name="add_circle">
                        <CirclePlus opacity={.6} size={23}/>
                    </Icon>
                </span>
            }>
                <Helmet>
                    <title>Paçoca - Meu anúncio</title>
                    <meta name="description" content={`Paçoca - Meu anúncio do Paçoca!`} />
                    <meta name="keywords" content={`Paçoca, rede social brasileira, Meu anúncio}`} />
                    <meta name="author" content="Paçoca Inc." />
                    <meta property="og:title" content={`Paçoca - Meu anúncio - Rede Social`} />
                    <meta property="og:description" content={`Paçoca - Meu anúncio`} />
                    <meta property="og:image" content="/img/link-preview.png?v=1" />
                    <meta property="og:url" content={window.location.href} />
                    <meta property="og:type" content="website" />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content={`Paçoca - Meu anúncio - Rede Social`} />
                    <meta name="twitter:description" content={`Paçoca - Meu anúncio do Paçoca`} />
                    <meta name="twitter:image" content="/img/link-preview.png?v=1" />
                </Helmet>

                <div className="container-register-community">
                        {loading && (
                            <PostLoading loading={loading}/>
                        )}
                   
                        {payment ? (
                            <>
                                <p className="w-100">Pague pelo QRCode ou copie o código no seu banco favorito:</p>
                                <h3 className="w-100 text-center" style={{marginTop: ""}}>R$ { formatCurrency(payment.valor) }</h3>
                                
                                <div className="d-flex">
                                    <img src={payment?.qrcode} width="300" alt="QR Code PIX" style={{margin: "0 auto"}}/>
                                </div>
                                
                                <div className="d-flex" style={{justifyContent: "right", marginBottom: "50px"}}>
                                    <button onClick={copyLink} type="button" className="btn btn-blue" style={{marginTop: ""}}>
                                        <Clipboard style={{height: "20px", marginRight: "9px"}}/>
                                        {copiado ? "Copiado!" : "Copiar código"}
                                    </button>

                                    <button disabled={loadingVerifyPayment} onClick={() => verifyPayment(true)} type="button" className="btn btn-blue" style={{marginLeft: "10px"}}>
                                        {loadingVerifyPayment ? (
                                            <Spinner size="20px"/>
                                        ) : (
                                            <div>
                                                    <CreditCard style={{height: "20px", marginRight: "9px"}}/> Verificar Pagamento
                                            </div>
                                        )} 
                                    </button>
                                </div>
                            </>
                        ) : null}

                        {/* <div className="col-12 mt-2">
                            {ad ? (
                               <>
                                {ad.status.includes("Reprovado") ? (
                                    <p className="text-red">
                                        {ad.status}
                                    </p>
                                ) : null}
                                
                                {ad?.views && ad?.views > 0 ? (
                                    <p className="w-100" style={{ marginBottom: 0 }}>{ad.views} visualizações</p>
                                ): null}

                                <p className="w-100">Preview do seu anúncio:</p>
                                <Ad numbers={expectedViews} ads={ad} />
                               </>
                            ) : null}
                        </div> */}
                        {ad ? (
                            <>
                                {ad.status.includes("Reprovado") && (
                                    <p style={{ color: 'var(--color-text-danger)', marginBottom: '1rem' }}>{ad.status}</p>
                                )}
                                <AdDashboard ad={ad} />
                            </>
                        ) : null}

                        
                        {ad?.status == "off" || ad?.status == "online" || ad?.status == "ativo" ? (
                            <>
                                <p>Anaize do Paçoca AI:</p>
                                <p>{!analyze.length && loadingAnalyze ? "Carregando" : null }</p>
                                <ReactMarkdown>
                                    {analyze}
                                </ReactMarkdown>
                            </>
                        ) : null}

                        {ad ? (
                            <>
                                <p className="w-100">Preview do seu anúncio:</p>
                                <Ad numbers={expectedViews} ads={ad} />
                            </>
                        ) : null}
                </div>

                <IncreaseLimit onIncreaseLimit={onIncreaseLimit} id_ads={ad?.id ?? 0}/>
            </Screen>
        </>
    );
};

export default ViewAds;